import { createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";

const initialState = {
  loading: false,
  postMessage: null,
  postError: null,
};

const postWhistleBlowingFormSlice = createSlice({
  name: "postWhistleBlowingForm",
  initialState,
  reducers: {
    postWhistleBlowingFormStart(state, payload) {
      state.loading = true;
      state.postError = null;
      state.postMessage = null;
    },

    postWhistleBlowingFormSuccess(state, action) {
      state.loading = false;
      state.postMessage = action.payload.postMessage;
      toast.success("Form Submitted!");
    },

    postWhistleBlowingFormFailure(state, action) {
      toast.error(action?.payload);

      state.loading = false;
      state.postError = action.payload;
      state.postMessage = null;
    },

    clearMessage: (state) => {
      state.postError = null;
      state.postMessage = null;
    },
  },
});

export const {
  postWhistleBlowingFormStart,
  postWhistleBlowingFormSuccess,
  postWhistleBlowingFormFailure,
  clearError,
  clearMessage,
} = postWhistleBlowingFormSlice.actions;

export default postWhistleBlowingFormSlice.reducer;
